@if (appleTVDisplays && nonAppleTVPresentations) {
  <div class="madero-style alert alert-warning tw-flex tw-flex-row tw-items-start" role="alert">
    <i aria-hidden="true" class="fa fa-exclamation-circle icon-left text-warning" style="line-height: inherit"></i>

    <div>
      <strong>Apple TV Compatibility Warning</strong>

      <div>
        One or more playlist items in your schedule will not play on your Apple TV.
      </div>
    </div>
  </div>
}
<div class="schedule-fields-body fields-preview-panels tw-flex tw-flex-col lg:!tw-flex-row">
  <div class="preview-container tw-h-full tw-flex tw-flex-col tw-items-center tw-flex-[2] tw-bg-gray-100">
    <div class="tw-w-full lg:tw-max-w-[768px] tw-flex tw-flex-col tw-px-6 tw-pt-6 xl:!tw-pt-24">
      <timeline-textbox
        [useLocaldate]="true"
        [(timelineObject)]="scheduleService.schedule"
        [readonly]="isAssignedPublisher"
        [showLabel]="true"
        [showScheduleDisclaimer]="true"
        inputId="-schedule"
        class="tw-border-0 tw-border-b tw-border-solid tw-border-gray-200 tw-pb-8 tw-mb-4">
      </timeline-textbox>
      <distribution-selector
        [(distribution)]="scheduleService.schedule.distribution"
        (distributionChange)="checkLicenseRequired()"
        [(subcompanyDistribution)]="scheduleService.schedule.subcompanyDistribution"
        [(distributeToSubcompanies)]="scheduleService.schedule.distributeToSubcompanies"
        (distributeToSubcompaniesChange)="distributeToSubcompaniesChange()"
        [(distributeToAll)]="scheduleService.schedule.distributeToAll"
        (distributeToAllChange)="checkLicenseRequired()"
        [enableSubcompanies]="true"
        [readonly]="isAssignedPublisher"
        [showLabel]="true"
        inputId="-schedule"
        class="tw-border-0 tw-border-b tw-border-solid tw-border-gray-200 tw-py-8 tw-mb-4">
      </distribution-selector>
      <div class="danger tw-mt-2" [shown]="freeDisplays?.length && licenseRequired && !playerLicenseService.updatingLicense && !playerLicenseService.apiError">
        You selected {{freeDisplays?.length}} unlicensed display{{freeDisplays?.length > 1 ? 's' : ''}} that won't show content. <a href="#" class="madero-link" (click)="licenseFreeDisplays()">License {{freeDisplays?.length > 1 ? 'them' : 'it'}}?</a>
      </div>
      <div class="danger tw-mt-2" [shown]="freeDisplays?.length && !licenseRequired && !playerLicenseService.updatingLicense && !playerLicenseService.apiError">
        You selected {{freeDisplays?.length}} unlicensed display{{freeDisplays?.length > 1 ? 's' : ''}}. <a href="#" class="madero-link" (click)="licenseFreeDisplays()">License {{freeDisplays?.length > 1 ? 'them' : 'it'}}?</a>
      </div>
      <div class="tw-mt-2" [shown]="playerLicenseService.updatingLicense">
        Assigning licenses <i aria-label="Loading" class="fa fa-spinner fa-spin fa-fw"></i>
      </div>
      <div class="danger tw-mt-2" [shown]="playerLicenseService.apiError">
        {{playerLicenseService.apiError}}
      </div>
      <schedule-type-selector
        [(scheduleType)]="scheduleService.schedule.scheduleType"
        (scheduleTypeChange)="scheduleTypeChange()"
        [(playOnce)]="scheduleService.schedule.playOnce"
        [readonly]="isAssignedPublisher"
        class="tw-mt-4">
      </schedule-type-selector>
      @if (scheduleService.schedule.id && scheduleService.schedule?.content?.length) {
        <div class="tw-text-right tw-mb-4" [shown]="isMobile">
          <button class="btn btn-default btn-toolbar tw-mr-4 xl:!tw-mr-0" (click)="isMobile = false">Show Preview</button>
        </div>
        <div class="preview-embed tw-mr-4 xl:!tw-my-4 xl:!tw-mr-0" [hidden]="isMobile">
          <iframe frameborder="0" [src]="isMobile ? '' : sanitizedPreviewUrl">
          </iframe>
        </div>
        <div class="tw-flex tw-flex-row tw-items-center tw-justify-between tw-pt-6 tw-pb-2">
          <mat-slide-toggle id="applyTimeline" name="applyTimeline" [(ngModel)]="applyTimeline">Apply Timeline to preview</mat-slide-toggle>
          <share-schedule-button class="tw-mr-4 xl:!tw-mr-0" buttonClass="tw-bg-white"></share-schedule-button>
        </div>
      }
      <div id="insecureUrlsErrorBox" [shown]="scheduleService.hasInsecureUrls() && !scheduleService.apiError" class="madero-style alert alert-danger tw-mt-4" role="alert">
        <strong>This schedule's playlist contains playlist items which can't show because the URL is insecure. Make sure the URLs begin with "HTTPS". If you need assistance, please email <a target="_blank" href="mailto:support@risevision.com">support&#64;risevision.com</a>.</strong>
      </div>
      <div id="errorBox" [shown]="scheduleService.apiError" class="madero-style alert alert-danger tw-mt-4" role="alert">
        <strong>{{scheduleService.apiError}}</strong>
      </div>
    </div>
  </div>

  <div class="tw-flex-1 tw-h-full tw-w-full lg:!tw-max-w-[33.33%] tw-overflow-y-auto tw-shadow-md">
    <div class="tw-py-8 tw-flex tw-flex-row tw-items-center tw-border-0 tw-border-solid tw-border-b tw-border-gray-200">
      <label class="tw-mb-0 tw-mr-auto tw-text-2xl tw-pl-6">Playlist:</label>
        <div class="dropdown" dropdown>
          <button id="addPlaylistItemButton" type="button" class="tw-mr-6" [matMenuTriggerFor]="playlistMenu" mat-stroked-button><mat-icon svgIcon="add" class="medium dark"></mat-icon>Add Playlist Item</button>
          <mat-menu #playlistMenu="matMenu">
            <button mat-menu-item id="addPresentationItemButton" (click)="addPresentationItem()" (keyup.enter)="addPresentationItem()">Presentation</button>
            <button mat-menu-item id="addUrlItemButton" (click)="addUrlItem()" (keyup.enter)="addUrlItem()">URL</button>
          </mat-menu>
        </div>
    </div>
    <playlist [playlistItems]="scheduleService.schedule.content" [shown]="scheduleService.schedule?.content?.length"></playlist>
    @if (!scheduleService.schedule?.content?.length) {
      <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-w-full tw-mt-12">
        <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-px-28 tw-py-6 tw-w-full">
          <mat-icon svgIcon="playlist" class="tw-w-20 tw-h-20"></mat-icon>
          <div class="form-group tw-mb-4 tw-mt-12">
            <p class="tw-text-2xl tw-font-bold tw-text-center">Start by adding playlist items.</p>
            <p class="tw-text-gray-500 tw-mt-2 tw-text-2xl tw-text-center">Build your schedule by adding playlist items.<br>Organize your content to play exactly how you want.</p>
          </div>
          <div class="dropdown tw-my-2" dropdown>
            <a id="addPlaylistItemButton" [matMenuTriggerFor]="playlistMenu" class="tw-text-green-700 tw-text-2xl tw-font-medium tw-no-underline tw-cursor-pointer" tabindex="1">
              Add Playlist Item
            </a>
            <mat-menu #playlistMenu="matMenu">
              <button mat-menu-item id="addPresentationItemButton" (click)="addPresentationItem()" (keyup.enter)="addPresentationItem()">Presentation</button>
              <button mat-menu-item id="addUrlItemButton" (click)="addUrlItem()" (keyup.enter)="addUrlItem()">URL</button>
            </mat-menu>
          </div>
        </div>
      </div>
    }
  </div>
</div>